import React from "react";
import { css } from "@emotion/react";
import { captionTypeface } from "./Text";
import { colorDark } from "../../stylingConstants";
import { useGlobalSiteData } from "../../hooks";
import { useCookieConsent } from "../../hooks/useCookieConsent";
import ContentfulRichText from "../Organisms/ContentPageRichText";
import { Button } from "./Button";

export default function CookieBanner() {
  const { cookieDisclaimer } = useGlobalSiteData();
  const { status, accept, reject } = useCookieConsent();

  return cookieDisclaimer?.raw != null && status === "pending" ? (
    <div
      css={css`
        font-family: ${captionTypeface};
        background: white;
        padding: 12px 16px;
      `}
      role="dialog"
      aria-label="Cookieinformation"
    >
      <ContentfulRichText json={cookieDisclaimer} />
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 12px;
        `}
      >
        <Button type="button" onClick={accept}>
          Acceptera
        </Button>
        <Button type="button" onClick={reject}>
          Avvisa
        </Button>
      </div>
    </div>
  ) : null;
}
